import { TenantDto, UserDto } from '@picflow/types';

export const getTenantGroups = (tenant: TenantDto) => {
  if (!tenant) return [];
  return Object.keys(tenant.onboarding_checklist)
    .filter(key => key.startsWith('ff_group_'))
    .map(key => key.replace('ff_group_', ''));
};

export const getUserGroups = (user: UserDto) => {
  if (!user) return [];
  if (user.email.includes('@nusign.com')) return ['internal'];
  return [];
};
